package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable
import kz.dentalcrm.app.data.network.response_model.PatientData
import kz.dentalcrm.app.data.network.response_model.TreatmentCourse
import kz.dentalcrm.app.data.network.response_model.employees.Employee

@Serializable
data class AppointmentRequest(
    val cash_box_id: Int?,
    val employee: Employee?,
    val ends_at: String?,
    val is_first_visit: Boolean?,
    val patient: PatientData?,
    val price: Int?,
    val services: List<AppointmentService>?,
    val starts_at: String?,
    val title: String?,
    val status: String?,
    val comment: String?,
    val treatment_course: TreatmentCourse? = null
)